import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class UploadApiService {
    private readonly baseUrl = environment.apiUrl

    constructor(private readonly http: HttpClient) {}

    submitDataset(
        datasetId: number,
        isMultiUploadMode: boolean,
        createDatasetsPerFolder: boolean
    ): Observable<unknown> {
        return this.http.put(`${this.baseUrl}/datasets/${datasetId}/submit`, {
            isMultiUploadMode: isMultiUploadMode,
            createDatasetsPerFolder: createDatasetsPerFolder,
        })
    }

    getCompletedUploadsForDataset(datasetId: number): Observable<CompletedFileUpload[]> {
        return this.http.get<CompletedFileUpload[]>(`${this.baseUrl}/datasets/${datasetId}/uploads`)
    }
}

interface CompletedFileUpload {
    filename: string
    total_size: number
    identifier: string
}
